import {
  LOAD_FDES_PARAMETERS,
  CHANGE_FDES_PARAMETER_FORM,
  SAVE_FDES_FORM,
  SAVE_FDES_FORM_REAL_TIME,
  SAVE_CURRENT_FDES_ID,
  LOAD_REFERENCE,
  CHANGE_SYNTHETIC_RESULT_FORM,
  CHANGE_MODULE_RESULT_FORM,
  CHANGE_CALCUL_NAME_FORM,
  SAVE_FDES_RESULT,
  CHANGE_PROJECT_NAME_FORM,
  UPDATE_CALCUL,
  CLEAN_NAME_FORM,
  UPGRADE_CALCUL,
  CLEAR_RECALC_AFTER_UPGRADE,
  GET_FDES_METADATA,
  POST_FDES_FILE,
  GET_FDES_METADATA_CALCUL_ROW,
  GENERATE_REPORTS,
  UPDATE_FORM_FIELDS,
  CLEAR_FIELDS_IMPORT_ERRORS,
  CHANGE_SIMULATION_MODE_FORM,
  BULK_GENERATE_REPORTS,
  BULK_DOWNLOAD_REPORTS,
  UPDATE_FORM_GROUP_STATE,
  CLEAR_USER_PARAMETERS_GROUPS,
} from "../constants";

export function loadFdesParameters(fdesId, api, calcul, isEditMode) {
  return {
    type: LOAD_FDES_PARAMETERS,
    fdesId,
    api,
    calcul,
    isEditMode,
  };
}

export function changeFdesParameterForm(paramId, value) {
  return {
    type: CHANGE_FDES_PARAMETER_FORM,
    paramId,
    value,
  };
}

export function saveFdesForm(fdesId) {
  return {
    type: SAVE_FDES_FORM,
    fdesId,
  };
}

export function postFdesFile(paramId, file) {
  return {
    type: POST_FDES_FILE,
    paramId,
    file,
  };
}

export function saveFdesRealTimeForm(api, fdesId) {
  return {
    type: SAVE_FDES_FORM_REAL_TIME,
    api,
    fdesId,
  };
}

export function saveFdesResult() {
  return {
    type: SAVE_FDES_RESULT,
  };
}

export function saveCurrentFdesId(fdesId) {
  return {
    type: SAVE_CURRENT_FDES_ID,
    fdesId,
  };
}

export function getFdesMetaData(fdesId) {
  return {
    type: GET_FDES_METADATA,
    fdesId,
  };
}

export function getFdesMetaDataForCalculRow(fdesId, resolve, reject) {
  return {
    type: GET_FDES_METADATA_CALCUL_ROW,
    fdesId,
    resolve,
    reject,
  };
}

export function loadReference(standard) {
  return {
    type: LOAD_REFERENCE,
    standard,
  };
}

export function changeSyntheticResultForm(field, value) {
  return {
    type: CHANGE_SYNTHETIC_RESULT_FORM,
    field,
    value,
  };
}

export function changeModuleResultForm(value) {
  return {
    type: CHANGE_MODULE_RESULT_FORM,
    value,
  };
}

export function changeCalculNameForm(value) {
  return {
    type: CHANGE_CALCUL_NAME_FORM,
    value,
  };
}

export function changeProjectName(value) {
  return {
    type: CHANGE_PROJECT_NAME_FORM,
    value,
  };
}

export function changeSimulationMode(value) {
  return {
    type: CHANGE_SIMULATION_MODE_FORM,
    value,
  };
}

export function generateReports(filesToGenerate, userFdesId, folderId) {
  return {
    type: GENERATE_REPORTS,
    filesToGenerate,
    userFdesId,
    folderId,
  };
}

export function updateCalcul(calculId) {
  return {
    type: UPDATE_CALCUL,
    calculId,
  };
}

export function cleanNameForm() {
  return {
    type: CLEAN_NAME_FORM,
  };
}

export function upgradeCalcul(calculId) {
  return {
    type: UPGRADE_CALCUL,
    calculId,
  };
}

export function clearRecalcAfterUpgrade() {
  return {
    type: CLEAR_RECALC_AFTER_UPGRADE,
  };
}

export function updateFields(fields) {
  return {
    type: UPDATE_FORM_FIELDS,
    fields,
  };
}

export function clearFieldsImportErrors(fields) {
  return {
    type: CLEAR_FIELDS_IMPORT_ERRORS,
    fields,
  };
}

export function bulkGenerateReports(calculs, folderId) {
  return {
    type: BULK_GENERATE_REPORTS,
    calculs,
    folderId,
  };
}

export function bulkDownloadReports(calculIds, types, folderId) {
  return {
    type: BULK_DOWNLOAD_REPORTS,
    calculIds,
    types,
    folderId,
  };
}

export function updateFormGroupState(groupName, value, order) {
  return {
    type: UPDATE_FORM_GROUP_STATE,
    groupName,
    value,
    order,
  };
}

export function clearUserParametersGroups() {
  return {
    type: CLEAR_USER_PARAMETERS_GROUPS,
  };
}
